import { render, staticRenderFns } from "./Warning-Barnewtop.vue?vue&type=template&id=e6766870&scoped=true&"
import script from "./Warning-Barnewtop.vue?vue&type=script&lang=js&"
export * from "./Warning-Barnewtop.vue?vue&type=script&lang=js&"
import style0 from "./Warning-Barnewtop.vue?vue&type=style&index=0&id=e6766870&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6766870",
  null
  
)

export default component.exports